module.exports = __webpack_public_path__ + "img/micro_brazil_dress.4ef7fdfc.jpg";